import { Record } from 'immutable';
import { handleActions } from 'redux-actions';
import { INITIAL_STEP, NEXT_STEP } from '../actions/index';

export const ReducerRecord = Record({
  step: 0,
  options: {},
});

export default handleActions({
  [INITIAL_STEP]() {
    return new ReducerRecord();
  },
  [NEXT_STEP](state, { payload: { options } }) {
    return state
      .set('step', state.step + 1)
      .set('options', options);
  },
}, new ReducerRecord());
